import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import map from 'lodash-es/map';
import toArray from 'lodash-es/toArray';
import Pagination from '@/blocks.04-project/slider-pagination/slider-pagination.tmpl-specs/base.module';
import Navigation from '@/blocks.04-project/slider-navigation/slider-navigation.tmpl-specs/base.module';
import { PaginationEvents } from '@/blocks.04-project/slider-pagination/slider-pagination';

/* Класс слайдера для контентных страниц */
class ContentSlider {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент формы с классом content-slider
   */
  constructor(elem) {
    this.BlockError = new BlockError({ blockName: 'ContentSlider', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');

    this.block = elem;
    this.block.ContentSlider = this;
    this.block.AsyncContentSlider = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'content-slider_inited'});
    window.getBH((bh) => {
      this.bh = bh;
      this.LazyInit.init();
    });
  }

  init = async () => {
    this.elements = toArray(this.block.children);

    this.renderSlider();
    await this.initSlider();

    this.promiseResolve(this);
    this.block.AsyncProductCard = this;
  };

  renderSlider = () => {
    this.block.innerHTML = '';
    this.block.insertAdjacentHTML('afterbegin', this.bh.apply([
      {cls: 'swiper', content: [
          {cls: 'swiper-wrapper', content: map(this.elements, (elem) => [
              {cls: 'swiper-slide', content: elem.outerHTML},
            ])},
          Navigation(),
        ]},
      {cls: 'text-center', content: [
          Pagination({count: this.elements.length}),
        ]},
    ]));
  };

  initSlider = async () => {
    this.paginationContainer = this.block.querySelector('.swiper-pagination');
    if (!this.paginationContainer) return this.BlockError.error('Отсутствует .swiper-pagination');

    this.navNext = this.block.querySelector('.swiper-button-next');
    if (!this.navNext) return this.BlockError.error('Отсутствует .swiper-button-next');

    this.navPrev = this.block.querySelector('.swiper-button-prev');
    if (!this.navPrev) return this.BlockError.error('Отсутствует .swiper-button-prev');

    const { Swiper, Modules } = await Promise.all([
      import(/* webpackChunkName: "Swiper" */ 'swiper'),
      import(
        /* webpackChunkName: "SwiperModules" */
        /* webpackExports: ['Pagination', 'Navigation'] */
        'swiper/modules')
    ]).then((data) => {
      return {
        Swiper: data[0]?.Swiper,
        Modules: toArray(data[1]),
      };
    }).catch((err) => {
      throw new Error(err);
    });

    this.swiper = new Swiper(this.block.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: this.paginationContainer,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev,
      },
      on: {
        ...PaginationEvents,
        afterInit: (swiper) => this.block.dispatchEvent(new CustomEvent('iv.swiper.inited', { bubbles: true, detail: swiper })),
      },
      modules: Modules,
    });
  };

  destroy = () => {
    if (this.swiper) this.swiper.destroy();
    if (this.LazyInit) this.LazyInit.destroy();
    if (this.block) {
      this.block.classList.remove('content-slider_inited');
      delete this.block.ContentSlider;
      delete this.block.AsyncContentSlider;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.content-slider:not(.content-slider_inited)')).forEach((elem) => new ContentSlider(elem));
  }
}

document.addEventListener('DOMContentLoaded', ContentSlider.init);

// Экспорт;
window.Block = window.Block ? window.Block : {};
window.Block.ContentSlider = ContentSlider;
